var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgNotPreferred = function SvgNotPreferred(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M9.591 16.02 7.29 13.645a.934.934 0 0 1 0-1.293.866.866 0 0 1 1.253 0l1.68 1.724 5.227-5.392a.866.866 0 0 1 1.253 0 .934.934 0 0 1 0 1.293l-5.857 6.043a.866.866 0 0 1-1.254 0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M20 6.688c0-.725-.418-1.385-1.058-1.678L12.72 2.158a1.72 1.72 0 0 0-1.44 0L5.058 5.01A1.85 1.85 0 0 0 4 6.688v4.31C4 16.085 7.413 20.844 12 22c4.587-1.155 8-5.914 8-11.003zM5.78 6.685 12 3.835l6.22 2.85.001.003.001.001v4.308c0 4.155-2.704 7.982-6.222 9.101-3.518-1.12-6.222-4.946-6.222-9.1v-4.31z",
    clipRule: "evenodd"
  })));
};
export default SvgNotPreferred;